import React, { useEffect, useState } from 'react';
import SideNav from 'ui/SideNav';
import { staffClient } from 'clients/staff';
import { set } from 'lodash';

const PDS_NAME = '일반게시판';

const menus = [
    {
        title: '메인',
        to: '/main/home',
    },
    {
        title: '공지사항',
        to: '/notice',
    },
    {
        title: '현장자료실',
        // 현장 상세(/sites/123)에서도 이 메뉴가 켜져 있어야 함
        activePaths: ['/sites'],
        subMenus: [
            {
                title: '감리현장',
                to: '/sites/list?category=SUPERVISION',
            },
            {
                title: '공사현장',
                to: '/sites/list?category=CONSTRUCTION',
            },
            {
                title: '설계현장',
                to: '/sites/list?category=DESIGN',
            },
            // {
            //     title: '감리원 현황',
            //     to: '/staff-assignment',
            // },
        ],
    },
    {
        title: PDS_NAME,
        subMenus: [
            {
                title: '자유게시판',
                to: '/board/free',
            },
            {
                title: '정보공유',
                to: '/board/info',
            },
            {
                title: '사진자료실',
                to: '/board/photo',
            }
        ],
    },
    // {
    //     title: '캘린더',
    //     to: '/calendar',
    // },
    {
        title: '계정',
        subMenus: [
            {
                title: '마이페이지',
                to: '/account/mypage',
            },
        ],
    },
    {
        title: '관리자',
        subMenus: [
            // {
            //     title: '게시글 관리',
            //     to: '/admin/articles',
            // },
            {
                title: '현장 관리',
                to: '/admin/site-management',
            },
            {
                title: '직원 관리',
                to: '/admin/staffs',
            },
            {
                title: '자격 현황',
                to: '/admin/qualifications',
            },
            // {
            //     title: '연차 관리',
            //     to: '/admin/annual-leave',
            // },
            // {
            //     title: '결재 관리',
            //     to: '/admin/approval',
            // },
            {
                title: '특허 관리',
                to: '/admin/patent',
            },
            {
                title: '상훈 관리',
                to: '/admin/award',
            },
            {
                title: '게시판 관리',
                to: '/admin/board-management',
            },
            {
                title: '홈페이지 관리',
                to: '/admin/website',
            },
            {
                title: '보안',
                to: '/admin/security',
            },
            // {
            //     title: '실적 관리',
            //     to: '/admin/performance',
            // },
        ],
    },
    // {
    //     title: '테스트',
    //     subMenus: [
    //         {
    //             title: '이미지 업로드',
    //             to: '/test/image',
    //         },
    //     ],
    // },
];

export default () => {
    const [boardSubmenus, setBoardSubmenus] = useState([]);
    const [staffType, setStaffType] = useState('');

    useEffect(() => {
        fetchBoards();
        fetchMyInfo()
    }, []);

    const fetchBoards = async () => {
        try {
            const ret = await staffClient.get(`/board/general`, { params: { limit: 1000 } });
            console.log("[SideNav] fetchBoards", ret);
            // 서버 응답 구조에 맞춰서 데이터 추출
            const boardData = ret?.data?.data?.data || ret?.data?.data || ret?.data || [];
            const publicBoards = boardData.filter((board) => board.visible === true) || [];
            const newBoardSubmenus = publicBoards
                .sort((a, b) => (a.order || 0) - (b.order || 0))
                .map((board) => {
                    return {
                        title: board.name,
                        to: `/board/${board.id}`,
                    };
                });
            console.log("[SideNav] fetchBoards newBoardSubmenus", newBoardSubmenus);
            setBoardSubmenus(newBoardSubmenus);
        } catch (e) {
            console.log("[SideNav] 서버 연결 실패 - 정적 메뉴 사용");
            // 서버 연결 실패 시 boardSubmenus는 빈 배열로 유지하여 정적 메뉴가 사용되도록 함
        }
    }

    const fetchMyInfo = async () => {
        try {
            const ret = await staffClient.get('/auth/my-info');
            console.log("[fetchMyInfo] ret", ret);
            const token = ret.data.token;
            setStaffType(token.type);
        } catch (e) {
            console.error("[fetchMyInfo] error", e);
        }
    }

    const menusWithBoards = menus.map((menu) => {
        if (menu.title === PDS_NAME) {
            return {
                ...menu,
                // 서버에서 데이터를 가져왔을 때만 덮어씌우고, 그렇지 않으면 정적 메뉴 유지
                subMenus: boardSubmenus.length > 0 ? boardSubmenus : menu.subMenus,
            }
        } else {
            return menu;
        }
    })

    // 권한에 따른 메뉴 필터링
    const menusWithAuth = menusWithBoards.filter((menu) => {
        if (staffType === 'STAFF') {
            return ['관리자', '테스트'].includes(menu.title) === false;
        }
        return true;
    });

    return <SideNav menus={menusWithAuth}></SideNav>;
};
